<div class="w-100 p-2 p-md-5 bg-navy-blue text-white">
    <!-- <div class="w-100 d-flex justify-content-between">
        <div class="col-12 col-md-4 d-flex flex-column flex-md-row justify-content-between font-weight-bold p-3 f-18">
            <div>Terms & conditions</div>
            <div>Contact</div>
            <div>Privacy policy</div>
        </div>
        <div class="col-4">

        </div>
    </div> -->
    <div class="w-100 d-flex flex-wrap align-items-center m-0 m-md-2">
        <div class="col-12 col-md-6 d-flex p-3 justify-content-center justify-content-md-start">
            <div class="font-inter-light">
                © 2022 Bitssa. All rights reserved.
            </div>
        </div>
        <div class="col-12 col-md-6 d-flex p-3 justify-content-center justify-content-md-end">
            <div class="mx-2">
                <a href="https://medium.com/@bitssa" target="_blank">
                    <img src="../../assets/images/medium_icon.png" alt="" width="42">
                </a>
            </div>
            <div class="mx-2">
                <a href="https://t.me/+fgb2iBqzvI1mYTQ1" target="_blank">
                    <img src="../../assets/images/telegram_icon.png" alt="" width="36">
                </a>
            </div>
        </div>
    </div>
</div>